export default __webpack_public_path__ + "static/media/noEntregado.25c5ae6f.svg";